module.exports = __webpack_public_path__ + "img/favoritep.d306ff6a.svg";